import { AlertsPortal } from '@/components/ui/alert/AlertsPortal'
import { useIsINSEnabled } from '@/shared/model/useIsINSEnabled'
import { INFO_PATIENT_PAGE_ALERTS } from '../model/constants'
import { usePatientAlerts } from '../model/usePaitentAlerts'

export function PatientAlerts({ patientId }: { patientId: string }) {
  const { isINSEnabled } = useIsINSEnabled()
  usePatientAlerts(patientId)

  if (!isINSEnabled) return null

  return <AlertsPortal area={INFO_PATIENT_PAGE_ALERTS} />
}
